import React from 'react';

const SocialLinks = () => {
  return (
      <div>
        <ul className="social-links">

      <li>
        <a href="https://www.facebook.com/arsen.babajanyan.5" target="_blank" rel="noopener noreferrer">
          <i className="icon icon-facebook"></i>
        </a>
      </li>
      <li>
        <a href="https://www.youtube.com/channel/UCi-4vpJzx9gi1ERtj_EmfaA" target="_blank" rel="noopener noreferrer">
          <i className="icon icon-youtube"></i>
        </a>
      </li>
        <li>
            <a href="https://www.instagram.com/babajanyan_arsen/" target="_blank" rel="noopener noreferrer">
                <i className="icon icon-insta"></i>
            </a>
        </li>
    </ul>
</div>
);
};

export default SocialLinks;
